import React from 'react';

interface Props {
  data: {
    country: string;
    state: string;
    city: string;
    phone: string;
    companyEmail: string;
  };
  updateData: (data: Partial<typeof Props['data']>) => void;
}

export const CompanyAddress = ({ data, updateData }: Props) => {
  return (
    <div>
      <h2 className="text-2xl font-semibold text-center text-gray-900 mb-2">
        Where are you located?
      </h2>
      <p className="text-center text-gray-600 mb-8">
        Provide your main office address and contact info.
      </p>

      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Country
            </label>
            <select
              value={data.country}
              onChange={(e) => updateData({ country: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4B6BFB] focus:border-transparent"
            >
              <option value="">Select country</option>
              <option value="US">United States</option>
              <option value="CA">Canada</option>
              <option value="GB">United Kingdom</option>
              <option value="AU">Australia</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              State / Province
            </label>
            <input
              type="text"
              value={data.state}
              onChange={(e) => updateData({ state: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4B6BFB] focus:border-transparent"
              placeholder="Enter state"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            City
          </label>
          <input
            type="text"
            value={data.city}
            onChange={(e) => updateData({ city: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4B6BFB] focus:border-transparent"
            placeholder="Enter city"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Contact Number
          </label>
          <div className="flex gap-2">
            <select
              className="w-24 px-2 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4B6BFB] focus:border-transparent"
            >
              <option value="+1">+1</option>
              <option value="+44">+44</option>
              <option value="+61">+61</option>
            </select>
            <input
              type="tel"
              value={data.phone}
              onChange={(e) => updateData({ phone: e.target.value })}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4B6BFB] focus:border-transparent"
              placeholder="(555) 000-0000"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Company Email
          </label>
          <input
            type="email"
            value={data.companyEmail}
            onChange={(e) => updateData({ companyEmail: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4B6BFB] focus:border-transparent"
            placeholder="company@example.com"
          />
        </div>
      </div>
    </div>
  );
};